import * as Yup from "yup";

// Valores iniciales
export function initialValuesFive(scene) {
  return {
    ModFiveCompetencies: scene?.ModFiveCompetencies || [
      { title: "", description: "" },
    ], // Array inicial para categorías
    ModFiveImagecompetencies: scene?.ModFiveImagecompetencies || null,
  };
}

// Esquema de validación
export function validationSchemaFive() {
  return Yup.object({
    ModFiveCompetencies: Yup.array()
      .of(
        Yup.object().shape({
          title: Yup.string().required(
            "El título de la categoría es obligatorio",
          ),
          description: Yup.string().required("La descripción es obligatoria"),
        }),
      )
      .min(1, "Debes añadir al menos una categoría"), // Valida que haya al menos una categoría
    ModFiveImagecompetencies: Yup.string().nullable(),
  });
}
